<div class="auth">
  <div class="left">
    <form class="auth-wrapper" [formGroup]="form" (submit)="submitted = true; send()">
      <span class="auth-title">
        @switch (pageType) {
          @case ('login') {
            Sign in to CybeReady
          }
          @case ('set-password') {
            Create a Password
          }
          @case ('reset-password') {
            Enter your email to reset password
          }
          @case ('2fa') {
            @if (totpMfa) {
              Enter your MFA verification code
            } @else {
              Please enter verification code
            }
          }
          @case ('setup') {
            Enable Multi-Factor Authentication (MFA)
          }
          @case ('change-password') {
            Change Password
          }
        }
      </span>
      <div class="auth-inputs ui-layout-column">
        @switch (pageType) {
          @case ('login') {
            <input matInput
                   [ngClass]="{'error': form.controls.email.invalid && form.controls.email.touched}"
                   formControlName="email" type="email" placeholder="Email address">
            <span class="input-error"
                  [ngClass]="{'error-visible': form.controls.email.invalid && form.controls.email.touched}">
              @if (!form.controls.email.value) {
                Please enter your email address
              } @else {
                Please fill in a correct email address
              }
            </span>
            <div class="password-row">
              <input matInput
                     [ngClass]="{'error': form.controls.password.invalid && form.controls.password.touched}"
                     formControlName="password" [type]="showPassword ? 'text' : 'password'" placeholder="Password">
              <img class="show-password-icon pointer" [src]="showPassword ? 'assets/svg/eye_login_hidden.svg' : 'assets/svg/eye_login.svg'" (click)="showPassword = !showPassword">
            </div>
            <span class="input-error"
                  [ngClass]="{'error-visible': form.controls.password.invalid && form.controls.password.touched}">Please enter your password</span>
          }

          @case ('set-password') {
            <div class="password-row">
              <input matInput formControlName="password" [type]="showPassword ? 'text' : 'password'" placeholder="Create a password">
              <img class="show-password-icon pointer" [src]="showPassword ? 'assets/svg/eye_login_hidden.svg' : 'assets/svg/eye_login.svg'" (click)="showPassword = !showPassword">
            </div>
            <div class="password-row">
              <input matInput
                     [ngClass]="{'error': form.controls.validatePassword.invalid && form.controls.validatePassword.touched}"
                     formControlName="validatePassword" placeholder="Confirm password" [type]="showValidatePassword ? 'text' : 'password'">
              <img class="show-password-icon pointer" [src]="showValidatePassword ? 'assets/svg/eye_login_hidden.svg' : 'assets/svg/eye_login.svg'" (click)="showValidatePassword = !showValidatePassword">
            </div>

            <div class="validation ui-layout-column">
              <p>Password must include at least:</p>
              <p [ngClass]="{'red': !validationError.character && validationDone,
              'green': validationError.character && validationDone}">
                @if (validationDone) {
                  <img [src]="validationError.character ? 'assets/svg/correct.svg' : 'assets/svg/incorrect.svg'"
                       alt="" class="margin-r-10">
                }
                8 characters
              </p>
              <p [ngClass]="{'red': !validationError.upperCase && validationDone,
              'green': validationError.upperCase && validationDone}">
                @if (validationDone) {
                  <img [src]="validationError.upperCase ? 'assets/svg/correct.svg' : 'assets/svg/incorrect.svg'"
                       alt="" class="margin-r-10">
                }
                1 uppercase letter
              </p>
              <p [ngClass]="{'red': !validationError.number && validationDone,
              'green': validationError.number && validationDone}">
                @if (validationDone) {
                  <img [src]="validationError.number ? 'assets/svg/correct.svg' : 'assets/svg/incorrect.svg'"
                       alt="" class="margin-r-10">
                }
                1 number
              </p>
              <p [ngClass]="{'red': !validationError.specialCharacter && validationDone,
              'green': validationError.specialCharacter && validationDone}">
                @if (validationDone) {
                  <img [src]="validationError.specialCharacter ? 'assets/svg/correct.svg' : 'assets/svg/incorrect.svg'"
                       alt="" class="margin-r-10">
                }
                1 special character
              </p>
              @if (form.controls.validatePassword.touched && form.errors?.passwordMismatch && validationDone) {
                <p [ngClass]="{'red':
                form.controls.validatePassword.touched && form.errors?.passwordMismatch && validationDone,
                'green':
                !form.controls.validatePassword.touched && form.errors?.passwordMismatch && validationDone}">
                  @if (validationDone) {
                    <img [src]="form.controls.validatePassword.touched && !form.errors?.passwordMismatch && validationDone ? 'assets/svg/correct.svg' : 'assets/svg/incorrect.svg'"
                         alt="" class="margin-r-10">
                  }
                  Password doesn’t match
                </p>
              }
            </div>
          }

          @case ('change-password') {
            <div class="password-row">
              <input matInput formControlName="oldPassword" [type]="showPassword ? 'text' : 'password'" placeholder="Old password">
              <img class="show-password-icon pointer" [src]="showPassword ? 'assets/svg/eye_login_hidden.svg' : 'assets/svg/eye_login.svg'" (click)="showPassword = !showPassword">
            </div>

            <div class="password-row">
              <input matInput formControlName="newPassword" [type]="showPassword ? 'text' : 'password'" placeholder="New password">
              <img class="show-password-icon pointer" [src]="showPassword ? 'assets/svg/eye_login_hidden.svg' : 'assets/svg/eye_login.svg'" (click)="showPassword = !showPassword">
            </div>

            <input matInput
                   [ngClass]="{'error': form.controls.retypeNew.invalid && form.controls.retypeNew.touched}"
                   formControlName="retypeNew" type="password" placeholder="Confirm password">

            <div class="validation ui-layout-column">
              <p>Password must include at least:</p>
              <p [ngClass]="{'red': !validationError.character && validationDone,
              'green': validationError.character && validationDone}">
                @if (validationDone) {
                  <img [src]="validationError.character ? 'assets/svg/correct.svg' : 'assets/svg/incorrect.svg'"
                       alt="" class="margin-r-10">
                }
                8 characters
              </p>
              <p [ngClass]="{'red': !validationError.upperCase && validationDone,
              'green': validationError.upperCase && validationDone}">
                @if (validationDone) {
                  <img [src]="validationError.upperCase ? 'assets/svg/correct.svg' : 'assets/svg/incorrect.svg'"
                       alt="" class="margin-r-10">
                }
                1 uppercase letter
              </p>
              <p [ngClass]="{'red': !validationError.number && validationDone,
              'green': validationError.number && validationDone}">
                @if (validationDone) {
                  <img [src]="validationError.number ? 'assets/svg/correct.svg' : 'assets/svg/incorrect.svg'"
                       alt="" class="margin-r-10">
                }
                1 number
              </p>
              <p [ngClass]="{'red': !validationError.specialCharacter && validationDone,
              'green': validationError.specialCharacter && validationDone}">
                @if (validationDone) {
                  <img [src]="validationError.specialCharacter ? 'assets/svg/correct.svg' : 'assets/svg/incorrect.svg'"
                       alt="" class="margin-r-10">
                }
                1 special character
              </p>
              @if (form.controls.newPassword.touched && form.errors?.passwordMismatch && validationDone) {
                <p [ngClass]="{'red':
                form.controls.retypeNew.touched && form.errors?.passwordMismatch && validationDone,
                'green':
                !form.controls.retypeNew.touched && form.errors?.passwordMismatch && validationDone}">
                  @if (validationDone) {
                    <img [src]="form.controls.retypeNew.touched && !form.errors?.passwordMismatch && validationDone ? 'assets/svg/correct.svg' : 'assets/svg/incorrect.svg'"
                         alt="" class="margin-r-10">
                  }
                  Password doesn’t match
                </p>
              }
            </div>
          }

          @case ('reset-password') {
            <input matInput
                   [ngClass]="{'error': form.controls.email.invalid && form.controls.email.touched}"
                   formControlName="email" type="email" placeholder="Email address">
            <span class="input-error"
                  [ngClass]="{'error-visible': form.controls.email.invalid && form.controls.email.touched}">
              @if (!form.controls.email.value) {
                Please enter your email address
              } @else {
                Please fill in a correct email address
              }
            </span>
          }

          @case ('2fa') {
            <input matInput
                   [ngClass]="{'error': form.controls.tfaCode.invalid && form.controls.tfaCode.touched}"
                   formControlName="tfaCode" type="text" placeholder="Verification Code">
            <span class="input-error"
                  [ngClass]="{'error-visible': form.controls.tfaCode.invalid && form.controls.tfaCode.touched}">
              @if (form.controls.tfaCode.hasError('required')) {
                Please enter your Two Factor Authentication code
              } @else {
                The verification code is incorrect
              }
            </span>
          }

          @case ('setup') {
            @if (setupTotpCode) {
              <div class="password-row">
                <p class="margin-b-10 totp-mfa">You can use any Authenticator app that supports Time-based, One Time Password (TOTP), such as Google Authenticator, Microsoft Authenticator and more. Scan the QR code below in your preferred Authenticator app or copy the secret code manually.</p>
                @if (qrCodeImageUrl) {
                  <div class="qr-code-container margin-b-10">
                    <img [src]="qrCodeImageUrl" alt="QR Code" width="256" height="256" />
                  </div>
                }
              </div>
            }
            <div class="setup-totp-code">
              <p class="setup-totp-label">Secret code:</p>
              <input matInput readonly [value]="setupTotpCode" placeholder="Setup Code">
              <p class="totp-mfa">Generated verification code:</p>
              <input matInput
                     [ngClass]="{'error': form.controls.tfaCode.invalid && form.controls.tfaCode.touched}"
                     formControlName="tfaCode" type="text" placeholder="">
              <span class="input-error"
                    [ngClass]="{'error-visible': form.controls.tfaCode.invalid && form.controls.tfaCode.touched}">
                @if (form.controls.tfaCode.hasError('required')) {
                  Please enter your Two Factor Authentication code
                } @else {
                  The verification code is incorrect
                }
              </span>
            </div>
          }
        }
      </div>
      <div class="auth-actions">
        @switch (pageType) {
          @case ('login') {
            <div class="ui-layout-row ui-layout-space-between">
              <span class="error-text">{{errorText}}</span>
              <a class="forgot-action pointer" [routerLink]="['/', 'forgot-password']">Forgot password?</a>
            </div>
            <button class="dashboard-button confirm">Log in <img src="assets/svg/arrow_right.svg" class="arrow" alt=""></button>
          }
          @case ('set-password') {
            <button class="dashboard-button confirm set-password-create">Create <img src="assets/svg/arrow_right.svg" class="arrow" alt=""></button>
          }
          @case ('change-password') {
            <a class="forgot-action pointer" [routerLink]="['/', 'login']">Cancel</a>
            <button class="dashboard-button confirm set-password-create">Save <img src="assets/svg/arrow_right.svg" class="arrow" alt=""></button>
          }
          @case ('reset-password') {
            <a class="forgot-action pointer" [routerLink]="['/', 'login']">Cancel</a>
            <button class="dashboard-button confirm">Reset Password</button>
          }
          @case ('2fa') {
            <div class="ui-layout-row align-baseline"
                 [ngClass]="{'ui-layout-space-between': rememberDeviceAllowed, 'justify-end': !rememberDeviceAllowed}">
              @if (rememberDeviceAllowed) {
                <mat-checkbox color="primary"
                              class="dashboard-checkbox tfa-control"
                              formControlName="persist">Remember this device</mat-checkbox>
              }
              @if (!totpMfa) {
                <a class="forgot-action pointer force-mfa-resend" [routerLink]="['/', 'login']">Resend code</a>
              }
            </div>
            <button class="dashboard-button confirm">Log in <img src="assets/svg/arrow_right.svg" class="arrow" alt=""></button>
          }
          @case ('setup') {
            <button class="dashboard-button confirm">Confirm <img src="assets/svg/arrow_right.svg" class="arrow" alt=""></button>
          }
        }
      </div>
    </form>

  </div>
  <div class="right">
    <img src="assets/svg/splashes.svg" alt="" class="splashes">
    <img src="assets/svg/cybeready-logo.svg" alt="" class="top-logo">
    <div class="graph-1">
      <span class="title">Increased <br> Phishing Detection</span>
      <img src="assets/gif/phishing_detection.gif" class="graph-1-icon">
    </div>
    <div class="graph-2">
      <span class="title">Risk Group Reduction</span>
      <img src="assets/gif/risk_reduction.gif" alt="" class="graph-2-icon">
    </div>
    <div class="graph-3">
      <span class="title">Complete<br>Workforce<br>Training</span>
      <img src="assets/svg/graph_3.svg" alt="" class="graph-3-icon">
    </div>
  </div>
</div>
